/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class PropertyValuationCasesAPI extends ApiClient {
  constructor() {
    super('property_valuation_cases', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  create(payload) {
    return axios.post(this.url, payload, requestConfig());
  }

  monthlyHistory(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, 'monthly_history'), params),
      requestConfig()
    );
  }

  review(id, payload) {
    return axios.post(
      resourcePath(this.url, id, 'review'),
      payload,
      requestConfig()
    );
  }

  adjustment(id, payload) {
    return axios.post(
      resourcePath(this.url, id, 'adjustment'),
      payload,
      requestConfig()
    );
  }

  backtest(id, payload) {
    return axios.post(
      resourcePath(this.url, id, 'backtest'),
      payload,
      requestConfig()
    );
  }

  createPublicLink(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'public_link'),
      payload,
      requestConfig()
    );
  }

  revokePublicLink(id, payload = {}) {
    return axios.delete(resourcePath(this.url, id, 'public_link'), {
      ...requestConfig(),
      data: payload,
    });
  }

  promotionReadiness(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'promotion_readiness'),
      payload,
      requestConfig()
    );
  }
}

export default new PropertyValuationCasesAPI();
